import { Link } from 'react-router-dom'

import { api } from '../../api/client'
import { useAsync } from '../../hooks/useAsync'
import { t } from '../../i18n/lingua'

/**
 * The choice of a **saved topology view** for the map widget: the views are
 * the ones people save in Rete → Mappa (filters, focus, depth, the positions
 * pinned by hand). The widget draws that view and colours it with Eagle; the
 * view itself is edited where it was made.
 */
export function SceltaVista({ viewId, onCambia }: { viewId: string; onCambia: (id: string, nome: string) => void }) {
  const viste = useAsync(() => api.topologyViews(), [])
  const elenco = viste.data ?? []
  return (
    <label className="field span-6">
      <span className="field__label">{t('Vista di topologia salvata')}</span>
      <select value={viewId} onChange={(e) => onCambia(e.target.value, elenco.find((v) => v.id === e.target.value)?.name ?? '')}>
        <option value="">—</option>
        {elenco.map((v) => (
          <option key={v.id} value={v.id}>
            {v.name}{v.positions && Object.keys(v.positions).length ? ` · ${t('{n} nodi fissati', { n: Object.keys(v.positions).length })}` : ''}
          </option>
        ))}
      </select>
      <span className="field__hint">
        {elenco.length === 0 && !viste.loading
          ? t('Nessuna vista salvata: aprila in Rete → Mappa, disponi i nodi e salva la vista.')
          : t('Le viste si creano e si modificano in Rete → Mappa; qui si scelgono.')}
        {' '}<Link to="/topology">{t('apri la mappa')}</Link>
      </span>
    </label>
  )
}
